module.exports = __webpack_public_path__ + "img/20.b39541b2.jpg";